// Горизонтальный список продуктов
class ProductListSwiper {
    constructor(swiperContainerSelector,
        slidesPerView = 5,
        spaceBetween = 16,
        breakpoints = {
            1680: {
                slidesPerView: 5,
                spaceBetween: 16,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 19,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 11,
            },
            320: {
                spaceBetween: 10,
                slidesPerView: "auto",
            },
        }) {
        this.swiper = new Swiper(swiperContainerSelector, {
            observer: true,
            observeParents: true,
            slidesPerView,
            spaceBetween,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: `${swiperContainerSelector} .swiper__btns .swiper__btn.next-btn`,
                prevEl: `${swiperContainerSelector} .swiper__btns .swiper__btn.prev-btn`,
            },
            breakpoints,
            on: {
                init: function (sw) {
                    $(sw.$el[0]).addClass("shown");
                },
            },
        });
    }
}

export default ProductListSwiper;
